import { Snack } from '@main/snackbar/const';

export const SNACKBAR_FEATURE = 'snackbar';

export interface StateWithSnackbar {
  [SNACKBAR_FEATURE]: SnackbarState;
}

export interface SnackbarState {
  snackbar: Snack[];
  hidden: boolean;
}

export interface SnackbarPersistenceState {
  hidden?: boolean;
}
